<p>
  alert-type works!
</p>
